import React, { useEffect, useMemo, useState } from 'react';
import "./HotelList.css"
import { BACKEND_URL } from "../../services/Helper";
import { toast } from "react-toastify";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import { sortHotelByDistance } from '../../utils/geoUtils';
import AOS from "aos";
import "aos/dist/aos.css";
import defaultimg from '../../Assets/hero.jpg';
const notifyA = (msg) => toast.error(msg);

const HotelList = () => {
    const navigate = useNavigate();
    const { location, locationName } = useOutletContext();
    const [userallhotel, setUserAllHotel] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const routeLocation = useLocation();
    const selectedCategory = routeLocation.state?.category || null;

    useEffect(() => {
        let mounted = true;

        const fetchAllHotel = async () => {
            if (!selectedCategory) return;
            setLoading(true);
            setError("");

            try {
                const res = await fetch(`${BACKEND_URL}/nearbe/getallShop?category=${selectedCategory}`, {
                    method: "GET",
                });

                const data = await res.json();
                if (!res.ok) throw new Error(data.message || "Failed to fetch shops");

                let shops = data.allShop || [];
                if (mounted) setUserAllHotel(shops);
            } catch (error) {
                if (mounted) {
                    setError(`Failed to load shops. Please refresh.`);
                    notifyA(`Could not load ${selectedCategory} shops. Please try again.`);
                    setUserAllHotel([]);
                }
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchAllHotel();

        return () => { mounted = false; };
    }, [selectedCategory]);

    const displayedHotels = useMemo(() => {
        return sortHotelByDistance(userallhotel, location);
    }, [userallhotel, location]);

    const filteredHotels = useMemo(() =>
        displayedHotels.filter((h) =>
            h?.shopName?.toLowerCase().includes(searchTerm.toLowerCase())
        ),
    [displayedHotels, searchTerm]);

    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);

    if (loading) return <p className="no-offer-msg">⏳ Loading Restaurants...</p>;
    if (error) return <p className="no-offer-msg">⚠️ {error}</p>;

    return (
        <div className='hotellist' data-aos="fade-up">
            {/* Location + search row */}
            <div className="hl-topbar">
                <div className="hl-location-info">
                    {selectedCategory && <span className="hl-cat-label">{selectedCategory}</span>}
                    {locationName && (
                        <span className="hl-loc-text">📍 {locationName}</span>
                    )}
                </div>
                <div className="offer-search-bar hl-search">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        placeholder="Search shops..."
                        className="offer-search-input"
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {filteredHotels.length === 0 ? (
                <p className="no-offer-msg">🚫 No shops found{selectedCategory ? ` for ${selectedCategory}` : ''}</p>
            ) : (
                <>
                    <p className="hl-count">{filteredHotels.length} shop{filteredHotels.length !== 1 ? 's' : ''} found</p>
                    <div className="hotel-grid" data-aos="zoom-in">
                        {filteredHotels.map((hotels) => (
                            <div
                                key={hotels._id}
                                className='hotel-card'
                                onClick={() => navigate("/userdashboard/restaurants/info", { state: { hotels } })}
                            >
                                <div className="hotel-img-wrapper">
                                    <img
                                        src={hotels.shopImage || defaultimg}
                                        alt={hotels.shopName}
                                        className="hotel-img"
                                    />
                                    <div className="hotel-img-gradient" />
                                    <span className="hotel-category-chip">{hotels.category || selectedCategory}</span>
                                    {typeof hotels.distance === "number" && (
                                        <span className="hotel-distance-chip">
                                            📍 {hotels.distance.toFixed(1)} km
                                        </span>
                                    )}
                                    {hotels.homeDelivery && (
                                        <span className="hotel-delivery-chip">🚚 Free Delivery</span>
                                    )}
                                </div>

                                <div className="hotel-info">
                                    <h3>{hotels.shopName}</h3>
                                    {hotels.address
                                        ? <p className="hotel-desc">📍 {hotels.address}</p>
                                        : <p className="hotel-desc">{hotels.category}</p>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );

}

export default HotelList
